module.exports = __webpack_public_path__ + "static/media/slider-three.a93bce01.webp";